export enum ShipType {
  COMMON = 'common',
  SPY = 'spy',
  COLONIZATION = 'colonization',
  MOON_DESTRUCTOR = 'moon_destructor',
  ENERGY = 'energy',
  RECYCLER = 'recycler',
}
